module.exports = __webpack_public_path__ + "static/media/jennetHydyrovaSmiling.a0352505.jpg";